import imgCropUrl from '@/home/utils/imgCropUrl';
import TrackWrapper from '~/components/common/TrackWrapper';
import { useIsMobile } from '~/context/common/DeviceContext';
import { BffFeedCardProps } from '~/contracts/home';
import { getNativeVdpPayload } from '~/native/home/utils';
import { defaultImageHandler } from '../../utils/defaultImageHandler';
import formatEvent from '../../utils/formatEvent';
import {
  Card,
  CardButtonBlue,
  CardDescription,
  CardHeader,
  CardImageSection,
  CardInfoSection,
  TrimMileage,
  VehicleDetails,
  VehicleImage,
  YearMakeModel
} from '../OrderStatusCards.styles';

function ReservedVehicleDetails({ feedItem }: BffFeedCardProps) {
  if (
    feedItem.content == null ||
    feedItem.content.vehicle == null ||
    feedItem.callToAction == null
  ) {
    return null;
  }

  const {
    callToAction: { link, title },
    content: {
      vehicle: { make, model, trim, year, id: vehicleId }
    }
  } = feedItem;

  return (
    <>
      <VehicleDetails>
        <YearMakeModel data-qa="purchase-in-progress-year-make-model">
          {year} {make} {model}
        </YearMakeModel>
        <TrimMileage data-qa="purchase-in-progress-trim">{trim}</TrimMileage>
      </VehicleDetails>
      <CardButtonBlue
        href={link}
        data-analytics-id="Home feed card"
        data-qa="Home reserved vehicle card - check status CTA"
        data-analytics-attributes={JSON.stringify({
          description: 'Reserved vehicle cta',
          vehicleId
        })}
        data-native-payload={getNativeVdpPayload(vehicleId)}
      >
        {title}
      </CardButtonBlue>
    </>
  );
}

export default function ReservedVehicleCard({ feedItem }: BffFeedCardProps) {
  const isMobile = useIsMobile();

  if (
    feedItem.content == null ||
    feedItem.content.vehicle == null ||
    feedItem.callToAction == null
  ) {
    return null;
  }

  const {
    callToAction: { link },
    content: {
      vehicle: { imageUrl, make, model, id: vehicleId }
    }
  } = feedItem;

  const customAttributes = {
    description: 'Reserved vehicle cta',
    vehicleId
  };

  return (
    <TrackWrapper
      event={formatEvent('Viewed - Home feed section', customAttributes)}
    >
      <Card data-qa="purchase-in-progress-card">
        <CardInfoSection>
          <CardHeader data-qa="purchase-in-progress-title">
            This {make} is reserved just for you!
          </CardHeader>
          <CardDescription data-qa="purchase-in-progress-text">
            We&apos;ll soon be inspecting and perfecting your new ride.
          </CardDescription>
          {!isMobile && <ReservedVehicleDetails feedItem={feedItem} />}
        </CardInfoSection>
        <CardImageSection>
          <a
            href={link}
            data-qa="purchase-in-progress-image-container"
            data-analytics-id="Home feed card"
            data-analytics-attributes={JSON.stringify(customAttributes)}
            data-native-payload={getNativeVdpPayload(vehicleId)}
          >
            <picture>
              <source
                srcSet={imgCropUrl(imageUrl, true)}
                media="(min-width=768px)"
              />
              <source
                srcSet={`${imageUrl}?trim=0.08&width=450&smart`}
                media="(min-width=320px)"
              />
              <VehicleImage
                data-qa="purchase-in-progress-image"
                alt={`${make} ${model}`}
                src={imgCropUrl(imageUrl, true)}
                onError={defaultImageHandler}
              />
            </picture>
          </a>
          {isMobile && <ReservedVehicleDetails feedItem={feedItem} />}
        </CardImageSection>
      </Card>
    </TrackWrapper>
  );
}
